import * as Sentry from "@sentry/react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const ENV = import.meta.env.MODE; // 'development' | 'production'

export function initMonitoring(): void {
  if (!SENTRY_DSN) return;
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENV,
    // Only sample errors in production — skip dev noise
    sampleRate: ENV === "production" ? 1.0 : 0,
    // Opt-in tracing if needed later; disabled for now (YAGNI)
    tracesSampleRate: 0,
    // Scrub user-identifiable data from breadcrumbs
    beforeBreadcrumb(crumb) {
      if (crumb.category === "ui.click") return null;
      return crumb;
    },
  });
}

export function captureError(
  err: unknown,
  context?: Record<string, unknown>,
): void {
  Sentry.withScope((scope) => {
    if (context) scope.setExtras(context);
    Sentry.captureException(err);
  });
}
